import Axios from 'axios';
import { useEffect } from 'react';
import checkinsRequest from './api/checkins.services';
import checkinsExportRequest from './api/checkinsExport.services';
import constants from '../constants';
import storage from '../storage';
import checkinDetailRequest from './api/checkinDetail.services';
import hotelsRequest from './api/hotels.service';
import updateHotelsRequest from './api/updateHotel.services';
import deleteHotelRequest from './api/deleteHotel.services';
import addHotelsRequest from './api/addHotel.services';
import salesChannelsRequest from './api/salesChannels.service';
import updateSalesChannelRequest from './api/updateSalesChannel.service';
import apiConfig from './api.config';
import addIhClientHotelRequest from './api/addIHClientHotel.services';
import appearenceRequest from './api/appearence.services';
import updateAppearenceRequest from './api/updateAppearence.service';
import languagesRequest from './api/languages.service';
import allHotelsRequest from './api/allHotels.service';
import uploadImageRequest from './api/uploadImage.services';
import checkinStats from './api/checkinStats.services';
import pmsHotelsRequest from './api/pmsHotels.service';
import pmsListRequest from './api/pmsList.service';
import pmsConfigHotelRequest from './api/pmsConfigHotel.service';
import pmsOauthHotelRequest from './api/pmsOauthHotel.service';
import createPremiumSuscription from './api/createPremiumSuscription.service';
import checkinConfigRequest from './api/checkinConfig.services';
import updateCheckinConfigRequest from './api/updateConfig.services';
import bookingSearchConfigRequest from './api/bookingSearchConfig.services';
import updateBookingSearchConfigRequest from './api/updateBookingSearch.services';
import bookingsRequest from './api/bookings.service';
import guestFormsRequest from './api/guestForms.service';
import setFormsVersion from './api/setFormsVersion.service';
import updateGuestFormRequest from './api/updateGuestForms.service';
import legalTextsRequest from './api/legalTexts.service';
import updateLegalTextRequest from './api/updateLegalTexts.service';
import communicationChannelsRequest from './api/communicationChannels.services';
import updateCommunicationEmails from './api/communicationEmails.service';
import checkinsStatsExportRequest from './api/checkinStatsExport.service';
import userRequest from './api/user.service';
import updateOwnerRequest from './api/updateOwner.service';
import updateUserRequest from './api/updateUser.service';
import loggedChangePasswordRequest from './api/auth/loggedChangePassword.service';
import userListRequest from './api/userList.services';
import unblockUserRequest from './api/unblockUser.service';
import sendUserInvitationRequest from './api/sendUserInvitation.service';
import deleteUserRequest from './api/deleteUser.service';
import updateChainAppearenceRequest from './api/updateChainAppearence.service';
import pmsPublicListRequest from './api/pmsPublicList.service';
import addOtaMarketing from './api/addOtaMarketing.service';
import getQuickguideImages from './api/getQuickguideImages.service';
import finishQuickguide from './api/finishQuickguide.service';
import registerPaperlessRequest from './api/auth/registerPaperless.service';
import pmsConfigRequest from './api/pmsConfig.service';
import pmsConfigDynamicFormRequest from './api/pmsConfigDynamicForm.service';
import pmsConfigDynamicFormByHotelIdRequest from './api/pmsConfigDynamicFormByHotelId.service';
import updatePmsConfigRequest from './api/updatePmsConfig.service';
import doorsOpeningByHotelListRequest from './api/doorsOpeningByHotelList.service';
import doorOpeningAddToHotelRequest from './api/doorOpeningAddToHotel.service';
import doorOpeningUpdateToHotelRequest from './api/doorOpeningUpdateToHotel.service';
import doorOpeningDeleteToHotelRequest from './api/doorOpeningDeleteToHotel.service';
import doorOpeningImportToHotelRequest from './api/doorOpeningImportToHotel.service';
import getPaymentsList from './api/getPaymentsList.service';
import getHotelPaymentConfig from './api/getHotelPaymentConfig.service';
import updateHotelPaymentConfig from './api/updateHotelPaymentConfig.service';
import getHotelsPaymentSelected from './api/getHotelsPaymentsSelected.service';
import doPmsConnectionCheck from './api/pmsConnectionCheck.service';
import doorOpeningDownloadTemplateRequest from './api/doorOpeningDownloadTemplate.service';
import doHealthCheckBooking from './api/doHealthCheckBooking.service';
import getDoorOpeningList from './api/doorOpeningList.services';
import getDoorOpeningHotels from './api/getHotelsSelectedDoorOpening.service';
import getHotelDoorOpeningConfig from './api/getHotelDoorOpeningConfig.service';
import updateHotelDoorOpeningConfig from './api/updateHotelDoorOpeningConfig.service';
import getAccountFunctionalities from './api/getAccountFunctionalities.service';
import requestFunctionalityContract from './api/requestFunctionalityContract.service';
import sendRequestFuncionalityEmail from './api/sendRequestFunctionalityEmail.service';
import getMailTemplates from './api/getMailTemplates.service';
import updateMailTemplateState from './api/updateMailTemplateState.service';
import getMailTemplateDetail from './api/getMailTemplateDetail.service';
import getTags from './api/getTags.service';
import sendTestEmail from './api/sendTestEmail.service';
import uploadMailAttachment from './api/uploadMailAttachment.service';
import updateMailTemplate from './api/updateMailTemplate.service';
import getGuestlinkOptions from './api/getGuestlinkOptions.service';
import createGuestlink from './api/createGuestlink.service';
import deleteGuestlink from './api/deleteGuestlink.service';
import purchasesList from './api/getPurchasesList.services';
import paymentsExportRequest from './api/paymentsExport.services';
import getEstablishmentTypes from './api/getEstablishmentTypes.services';
import getPaperlessPushConfig from './api/getPaperlessPushConfig.service';
import updatePaperlessPushConfig from './api/updatePaperlessPushConfig.service';
import postSendPoliceReport from './api/postSendPoliceReport.service';
import getPoliceReportList from './api/getPoliceReportList.service';
import getPoliceReportDetail from './api/getPoliceReportDetail.service';
import downloadPoliceReports from './api/downloadPoliceReport.services';
import getPoliceConfig from './api/getPoliceConfig.service';
import updatePoliceSFTP from './api/updatePoliceSFTP.service';
import updatePoliceSES from './api/updatePoliceSES.service';
import updatePoliceERTZ from './api/updatePoliceERTZ.service';
import updatePoliceMOSSOS from './api/policeReport/updatePoliceMOSSOS.service';
import deletePoliceERTZFile from './api/policeReport/deletePoliceERTZFile.service';
import uploadERTZFile from './api/policeReport/uploadERTZFile.service.js';
import getGuestlinkSmtpConfig from './api/getGuestlinkSmtpConfig.service';
import updateGuestlinkSmtpConfig from './api/updateGuestlinkSmtpConfig.service';
import getGuestlinkSmtpAuthConfig from './api/getGuestlinkSmtpAuthConfig.service';
import updateGuestlinkSmtpAuthConfig from './api/updateGuestlinkSmtpAuthConfig.service';
import checkSmtpConnection from './api/checkSmtpConnection.service';
import googleAuthApi from './api/googleAuthApi.service';
import bookingsExportRequest from './api/bookingsExport.services';
import getBillingInformation from './api/billing/getBillingInformation.service';
import saveBillingInformation from './api/billing/saveBillingInformation.service';
import handleSuscriptionRequest from './api/handleSuscription.service';
import getPaymentSuscriptionStatus from './api/getPaymentSuscriptionStatus.service';
import getDoorOpeningSuscriptionStatus from './api/getDoorOpeningSuscriptionStatus.service';
import getGuestlinkSuscriptionStatus from './api/getGuestlinkSuscriptionStatus.service';
import getHotelContractList from './api/billing/getHotelContractList.service';
import getHotelContractFileURL from './api/billing/getHotelContractFileURL.service';
import createHotelContract from './api/billing/saveHotelContract.service';
import deleteHotelContract from './api/billing/deleteHotelContract.service';
import editHotelContract from './api/billing/editHotelContract.service';
import getHotelLicencesList from './api/billing/getHotelLicencesList.service.js';
import updateHotelLicenceEnd from './api/billing/updateHotelLicenceEnd.service.js';
import getHotelBillingConfiguration from './api/billing/getHotelBillingConfiguration.service';
import deleteHotelLicence from './api/billing/deleteHotelLicence.service';
import editHotelLicence from './api/billing/editHotelLicence.service.js';
import saveBulkHotelLicence from './api/billing/saveBulkHotelLicence.service.js';
import getHotelInvoiceFileURL from './api/billing/getHotelInvoiceFileURL.service';
import getHotelInvoicesList from './api/billing/getHotelInvoicesList.service.js';
import deleteHotelInvoice from './api/billing/deleteHotelInvoice.service';
import saveHotelInvoice from './api/billing/saveHotelInvoice.service';
import editHotelInvoice from './api/billing/editHotelInvoice.service.js';
import findHotelInvoiceByInvoiceId from './api/billing/findHotelInvoiceByInvoiceId.service';
import findHotelInvoiceByInvoiceInternalId from './api/billing/findHotelInvoiceByInvoiceInternalId.service';
import updateHotelStatusId from './api/updateHotelStatusId.service';
import getOneHotel from './api/getOneHotel.service';
import getCheckOuts from './api/check-out/getCheckOuts.service';
import getCheckOutSubscriptionStatus from './api/check-out/getCheckOutSubscriptionStatus';
import getCheckInSubscriptionStatus from './api/getCheckInSubscriptionStatus.service';
import policeReportCheckSFTPConnection from './api/policeReportCheckSFTPConnection.service';
import policeReportValidateFileExport from './api/policeReportValidateFileExport.service';
import policeReportCheckSESConnection from './api/policeReportCheckSESConnection.service';
import validationRequests from './api/validations';
import setDoorOpeningOauth from './api/doorOpening/setDoorOpeningOauth.service';
import getOauth from './api/oauth/getOauth.service';
import forcePoliceReportDownloadTrigger from './api/forcePoliceReportDownloadTrigger';
import uploadSliderImage from './api/uploadSliderImage.service';
import removeSliderImage from './api/removeSliderImage.service';
import getGuestLinkTemplatesAndSubjectsFromLang from './api/guestlink/getTemplatesAndSubjectsFromLang.service';
import pmsGetUdfConfigRequest from './api/pmsGetUdfConfig.service';
import pmsCreateUdfConfigRequest from './api/pmsCreateUdfConfig.service';
import pmsUpdateUdfConfigRequest from './api/pmsUpdateUdfConfig.service';
import pmsDeleteUdfConfigRequest from './api/pmsDeleteUdfConfig.service';
import getActiveDashboardAlerts from './api/getActiveDashboardAlerts.service.js';
import validateUserPassword from './api/validateUserPassword.service.js';
import registerDashboardAction from './api/registerDashboardAction.service.js';
import getDownloadFiles from './api/policeReport/getDownloadFiles.service';
import policeReportSendAllErrors from './api/policeReport/policeReportSendAllErrors.service';
import policeReportSendDelete from './api/policeReport/sendDelete.service';
import getHardCheckinValues from './api/pms/getHardCheckin.service';
import updateHardCheckin from './api/pms/updateHardCheckin.service';
import getPaperlessDevices from './api/paperless/getPaperlessDevices.service';
import deletePaperlessDevice from './api/paperless/deletePaperlessDevice.service';
import getPaperlessUserHotels from './api/sales-chanel/getPaperlessUserHotels.service';
import updatePaperlessUserHotels from './api/sales-chanel/updatePaperlessUserHotels.service';
import updatePaperlessDevice from './api/paperless/updatePaperlessDevice.service';
import getAccountActiveFunctionalities from './api/account/getAccountActiveFunctionalities.service';
import autoCreatePaperlessUser from './api/sales-chanel/autoCreatePaperlessUser.service';
import setHotelSlugRequest from './api/setHotelSlug.service';
import setChainSlugRequest from './api/setChainSlug.service';
import generatePreviewPdf from './api/generatePreviewPdf.service';
import getHotelCheckinConfig from './api/checkin/getHotelCheckinConfig.service';
import updateHotelCheckinConfig from './api/checkin/updateHotelCheckinConfig.service';
import policeReportCheckS3Connection from './api/policeReportCheckS3Connection.service';
import policeReportValidateFileExportS3 from './api/policeReportValidateFileExportS3.service';
import getHotelTexts from './api/texts/getHotelTexts.service';
import getSftpConfig from './api/sftp/getSftpConfig.service';
import updateSftpConfig from './api/sftp/updateSftpConfig.service';
import checkSftpConnection from './api/sftp/checkSftpConnection.service';
import processHotelsFile from './api/hotels/processHotelsFile.service';
import send2fa from './api/2fa/send2fa.service';
import confirm2fa from './api/2fa/confirm2fa.service';
import getApiPaperlessCrendetials from './api/paperless/getApiPaperlessCredentials';
import checkApiPaperlessCrendetials from './api/paperless/checkApiPaperlessCredentials';
import getBookingReportConfig from './api/policeReport/getBookingReportConfig.service';
import getBookingReportList from './api/policeReport/getBookingReportList.service';
import getBookingReportDetail from './api/policeReport/getBookingReportDetail.service';
import sendBookingReport from './api/policeReport/sendBookingReport.service';
import forceBookingReport from './api/policeReport/forceBookkingReport.service';
import bookingReportSendDelete from './api/policeReport/sendRHDelete.service';
import getHbxSuscriptionStatus from './api/hbxProducts/getHbxSuscriptionStatus.service';
import sendOptIn from './api/hbxProducts/sendOptIn.service';
import sendOptOut from './api/hbxProducts/sendOptOut.service';
import bookingReportgetDownloadFiles from './api/policeReport/bookingReportgetDownloadFiles.service';
import getCopyFormConfigCompatibility from './api/getCopyFormConfigCompatibility.service';
import copyFormConfig from './api/copyFormConfig.service';
import processPMSConfigFile from './api/pms/processPMSConfigFile.service';
import setCarouselUrl from './api/setCarouselUrl.services';
import invoiceUploadDocumentTemplate from './api/hbxProducts/invoiceUploadDocumentTemplate.service';
import invoiceUploadInvoiceSample from './api/hbxProducts/invoiceUploadInvoiceSample.service';
import invoiceTemplateDeleteFile from './api/hbxProducts/invoiceTemplateDeleteFile.service';
import invoiceTemplateCheckFileExists from './api/hbxProducts/invoiceTemplateCheckFileExists.service';
import invoiceGetDocumentTemplate from './api/hbxProducts/invoiceGetDocumentTemplate.service';
import invoiceGetListTemplate from './api/hbxProducts/invoiceGetListTemplate.service';
import invoiceDeleteDocumentTemplate from './api/hbxProducts/invoiceDeleteDocumentTemplate.service';
import getInvoiceSFTP from './api/hbxProducts/getInvoiceSFTP.service';
import saveInvoiceSFTP from './api/hbxProducts/saveInvoiceSFTP.service';
import saveS3Users from './api/hbxProducts/saveS3Users.service';
import getS3Users from './api/hbxProducts/getS3Users.service';
import deleteS3Users from './api/hbxProducts/deleteS3Users.service';
import checkInvoiceSFTPConnection from './api/hbxProducts/checkInvoiceSFTPConnection.service';
import createPoliceS3User from './api/policeReport/createS3UserConfig.service';
import getPoliceS3UserConfig from './api/policeReport/getPoliceS3UserConfig.service';
import createBooking from './api/createBooking.service';
import updateBookingStatus from './api/updateBookingStatus.service';
import customerListRequest from './api/customerList.services';
import sendCustomerInvitationRequest from './api/sendCustomerInvitation.service';
import getHBXAggregatorChannels from './api/hbxAggregator/getHBXAggregatorChannels.service';
import getHBXChannelHotelFields from './api/hbxAggregator/getChannelHotelFields.service';
import getHBXChannelHotelActive from './api/hbxAggregator/getChannelHotelActive.service';
import saveChannelConfig from './api/hbxAggregator/saveChannelConfig.service';
import changeChannelStatus from './api/hbxAggregator/changeChannelStatus.service';
import getSelectOptions from './api/hbxAggregator/getSelectOptions.service';
import updatePoliceAlloggiati from './api/policeReport/updatePoliceAlloggiati.service';

export default function useApi({ appState, appActions }) {
  useEffect(() => {
    if (appState && appActions) {
      setUpInterceptors();
      if (appState?.accessToken) {
        loadAllHotels();
        loadQuickguideImages();
      }
    }
  }, [, appState?.accessToken]);

  function setUpInterceptors() {
    console.log('#API: Setting up interceptor');
    Axios.interceptors.request.use(
      request => {
        if (request.url !== apiConfig.bookingOauth && request.url !== apiConfig.cloudbedsOauth) {
          const storedCredentials = storage.get(constants.AUTH.USER_KEY);
          if (storedCredentials) {
            const { accessToken } = JSON.parse(storedCredentials);
            request.headers.Authorization = `Bearer ${accessToken}`;
          }
        }

        appActions.refreshSessionTimeLeft();

        return request;
      },
      error => {
        return error;
      }
    );

    const responseInterceptor = Axios.interceptors.response.use(
      response => {
        if (
          response.config.url !== apiConfig.bookingOauth ||
          !response.config.url.includes(apiConfig.validationsHost)
        ) {
          if (isUnauthorizedResponse(response)) {
            Axios.interceptors.response.eject(responseInterceptor);
            console.warn('401 - Unauthorized');
            deleteUserToken();
            return Promise.reject();
          } else {
            return response;
          }
        }
      },
      error => {
        if (error && error.response && isUnauthorizedResponse(error.response)) {
          console.warn('401 - Unauthorized');
          deleteUserToken();
          return Promise.reject();
        } else return rejectError(error);
      }
    );

    function isUnauthorizedResponse(response) {
      return (
        response &&
        response.status === 401 &&
        !response.config.url.includes(apiConfig.URIs.allHotels)
      );
    }

    function rejectError(error) {
      return Promise.reject(error);
    }
  }

  function deleteUserToken() {
    appActions.logout();
  }

  function loadAllHotels() {
    console.log('#API: Loading hotels list');
    allHotelsRequest()
      .then(res => {
        appActions.setHotelList(res);
        if (!appActions.getSelectedHotel()) {
          const hotel = { ...res[0], key: res[0].id, value: res[0].name, slug: res[0].slug };
          appActions.setSelectedHotel(hotel);
        }
      })
      .catch(err => {
        console.warn(err);
      });
  }

  function loadQuickguideImages() {
    console.log('#API: Loading quickguide images');
    getQuickguideImages()
      .then(res => {
        appActions.setQuickguideImages(res);
      })
      .catch(err => {
        console.warn(err);
      });
  }

  return {
    API: {
      getCheckOuts,
      checkinsRequest,
      checkinsExportRequest,
      checkinDetailRequest,
      hotelsRequest,
      updateHotelsRequest,
      deleteHotelRequest,
      addHotelsRequest,
      salesChannelsRequest,
      updateSalesChannelRequest,
      addIhClientHotelRequest,
      appearenceRequest,
      setCarouselUrl,
      updateAppearenceRequest,
      languagesRequest,
      allHotelsRequest,
      uploadImageRequest,
      checkinStats,
      pmsHotelsRequest,
      pmsListRequest,
      pmsConfigHotelRequest,
      pmsOauthHotelRequest,
      createPremiumSuscription,
      checkinConfigRequest,
      updateCheckinConfigRequest,
      bookingSearchConfigRequest,
      updateBookingSearchConfigRequest,
      bookingsRequest,
      guestFormsRequest,
      setFormsVersion,
      updateGuestFormRequest,
      legalTextsRequest,
      updateLegalTextRequest,
      communicationChannelsRequest,
      updateCommunicationEmails,
      checkinsStatsExportRequest,
      userRequest,
      updateOwnerRequest: updateOwnerRequest,
      updateUserRequest: updateUserRequest,
      loggedChangePasswordRequest,
      userListRequest,
      unblockUserRequest,
      sendUserInvitationRequest,
      deleteUserRequest,
      updateChainAppearenceRequest,
      pmsPublicListRequest,
      addOtaMarketing,
      getQuickguideImages,
      finishQuickguide,
      registerPaperlessRequest,
      pmsConfigRequest,
      pmsConfigDynamicFormRequest,
      pmsConfigDynamicFormByHotelIdRequest,
      updatePmsConfigRequest,
      pmsGetUdfConfigRequest,
      pmsCreateUdfConfigRequest,
      pmsUpdateUdfConfigRequest,
      pmsDeleteUdfConfigRequest,
      doorsOpeningByHotelListRequest,
      doorOpeningAddToHotelRequest,
      doorOpeningUpdateToHotelRequest,
      doorOpeningDeleteToHotelRequest,
      doorOpeningImportToHotelRequest,
      getPaymentsList,
      getHotelPaymentConfig,
      updateHotelPaymentConfig,
      getHotelsPaymentSelected,
      doPmsConnectionCheck,
      doorOpeningDownloadTemplateRequest,
      doHealthCheckBooking,
      getDoorOpeningList,
      getDoorOpeningHotels,
      getHotelDoorOpeningConfig,
      updateHotelDoorOpeningConfig,
      getAccountFunctionalities,
      requestFunctionalityContract,
      sendRequestFuncionalityEmail,
      getMailTemplates,
      updateMailTemplateState,
      getMailTemplateDetail,
      getTags,
      sendTestEmail,
      uploadMailAttachment,
      updateMailTemplate,
      getGuestlinkOptions,
      createGuestlink,
      deleteGuestlink,
      purchasesList,
      paymentsExportRequest,
      getEstablishmentTypes,
      getPaperlessPushConfig,
      updatePaperlessPushConfig,
      getPoliceReportList,
      getPoliceReportDetail,
      postSendPoliceReport,
      downloadPoliceReports,
      getPoliceConfig,
      updatePoliceSFTP,
      updatePoliceSES,
      updatePoliceERTZ,
      updatePoliceMOSSOS,
      uploadERTZFile,
      getGuestlinkSmtpConfig,
      updateGuestlinkSmtpConfig,
      getGuestlinkSmtpAuthConfig,
      updateGuestlinkSmtpAuthConfig,
      checkSmtpConnection,
      googleAuthApi,
      bookingsExportRequest,
      getBillingInformation,
      saveBillingInformation,
      handleSuscriptionRequest,
      getPaymentSuscriptionStatus,
      getDoorOpeningSuscriptionStatus,
      getGuestlinkSuscriptionStatus,
      getCheckOutSubscriptionStatus,
      getCheckInSubscriptionStatus,
      getHotelContractList,
      getHotelContractFileURL,
      createHotelContract,
      deleteHotelContract,
      editHotelContract,
      getHotelLicencesList,
      updateHotelLicenceEnd,
      getHotelBillingConfiguration,
      deleteHotelLicence,
      saveBulkHotelLicence,
      editHotelLicence,
      getHotelInvoiceFileURL,
      getHotelInvoicesList,
      deleteHotelInvoice,
      saveHotelInvoice,
      editHotelInvoice,
      findHotelInvoiceByInvoiceId,
      findHotelInvoiceByInvoiceInternalId,
      updateHotelStatusId,
      getOneHotel,
      policeReportValidateFileExport,
      policeReportValidateFileExportS3,
      policeReportCheckSFTPConnection,
      policeReportCheckS3Connection,
      policeReportCheckSESConnection,
      setDoorOpeningOauth,
      getOauth,
      forcePoliceReportDownloadTrigger,
      uploadSliderImage,
      removeSliderImage,
      getGuestLinkTemplatesAndSubjectsFromLang,
      ...validationRequests,
      getActiveDashboardAlerts,
      deletePoliceERTZFile,
      validateUserPassword,
      registerDashboardAction,
      getDownloadFiles,
      policeReportSendAllErrors,
      policeReportSendDelete,
      getHardCheckinValues,
      updateHardCheckin,
      getPaperlessDevices,
      deletePaperlessDevice,
      getPaperlessUserHotels,
      updatePaperlessUserHotels,
      updatePaperlessDevice,
      getAccountActiveFunctionalities,
      autoCreatePaperlessUser,
      setHotelSlugRequest,
      setChainSlugRequest,
      generatePreviewPdf,
      getHotelCheckinConfig,
      updateHotelCheckinConfig,
      getHotelTexts,
      getSftpConfig,
      updateSftpConfig,
      checkSftpConnection,
      processHotelsFile,
      send2fa,
      confirm2fa,
      getApiPaperlessCrendetials,
      checkApiPaperlessCrendetials,
      getBookingReportConfig,
      getBookingReportList,
      getBookingReportDetail,
      sendBookingReport,
      forceBookingReport,
      bookingReportSendDelete,
      getHbxSuscriptionStatus,
      sendOptIn,
      sendOptOut,
      bookingReportgetDownloadFiles,
      getCopyFormConfigCompatibility,
      copyFormConfig,
      processPMSConfigFile,
      invoiceUploadDocumentTemplate,
      invoiceGetDocumentTemplate,
      invoiceGetListTemplate,
      invoiceDeleteDocumentTemplate,
      getInvoiceSFTP,
      saveInvoiceSFTP,
      saveS3Users,
      getS3Users,
      deleteS3Users,
      invoiceUploadInvoiceSample,
      invoiceTemplateCheckFileExists,
      checkInvoiceSFTPConnection,
      invoiceTemplateDeleteFile,
      createPoliceS3User,
      getPoliceS3UserConfig,
      createBooking,
      updateBookingStatus,
      customerListRequest,
      sendCustomerInvitationRequest,
      getHBXAggregatorChannels,
      getHBXChannelHotelFields,
      getHBXChannelHotelActive,
      saveChannelConfig,
      changeChannelStatus,
      getSelectOptions,
      updatePoliceAlloggiati,
    },
  };
}
